import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';

import { DeviceVariable, Event } from '@iot-platform/models/i4b';
import { DateFormatPipe, InfoDisplayPipe, NumberFormatPipe, ValueUnitFormatPipe } from '@iot-platform/pipes';
import { TranslatePipe } from '@ngx-translate/core';
import { CardLoaderComponent } from '../../card-loader/card-loader.component';

@Component({
  imports: [FlexLayoutModule, TranslatePipe, InfoDisplayPipe, DateFormatPipe, ValueUnitFormatPipe, CardLoaderComponent],
  providers: [InfoDisplayPipe, NumberFormatPipe, DateFormatPipe, ValueUnitFormatPipe],
  selector: 'iot-platform-ui-detail-device-variable-card',
  templateUrl: './detail-device-variable-card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./detail-device-variable-card.component.scss']
})
export class DetailDeviceVariableCardComponent {
  currentDeviceVariable = input<DeviceVariable | null | undefined>(undefined);
  event = input<Event>();

  computedContextVariable = computed(() => {
    const contextVar = this.event()?.context?.deviceVariable;
    return contextVar ? ({ unit: contextVar.unit, lastValue: { value: contextVar.value } } as DeviceVariable) : undefined;
  });
}
